const BANNER_TEXT = "CUI//FEDCON";

type CuiBannerProps = {
  position: "top" | "bottom";
};

export const CuiBanner = ({ position }: CuiBannerProps) => {
  const isTop = position === "top";

  return (
    <div
      className={`flex items-center justify-center gap-2 bg-[#007315] font-semibold text-white ${
        isTop
          ? "sticky top-0 z-[9999] p-2 text-base leading-6"
          : "fixed bottom-0 left-0 right-0 z-[9999] px-2 py-1 text-sm leading-5"
      }`}
    >
      {BANNER_TEXT}
    </div>
  );
};
